const QA = [
  {
    q: 'セレクトする時に一番大事にしていることは？',
    a: '選ぶのは自分が日々飾りたいって、本心から思えるものだけです。「多分みんなこれ好きそう」みたいなのは一切ないです。',
  },
  {
    q: '強く惹かれるのはどんなバラ？',
    a: 'その品種の特性が顕著に出てるもの。あと変化が大きいもの。開いていくと全然違う顔になるようなのは、もう好きです。',
  },
  {
    q: '毎回全然違うバラが届く？',
    a: '常に新鮮な気持ちでいてほしいので、なるべく印象が違うものを選びます。そこは自分の今の気分に合わせすぎないように。本当に気分だけで選んだら、3か月ずっと同じとかになっちゃうので。',
  },
  {
    q: 'バラって品種名もかわいい！誰がつけてるんですか？',
    a: '品種名は生産者さんがつけてるんですよ。家族の名前をつける方もいるし、好きな曲の歌詞から取ってる方もいて。名前を知るとより愛着が湧くのでぜひ注目してほしいです！',
  },
]

export const InterviewSection: React.FC = () => {
  return (
    <section className="bg-white py-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-4">
        <div className="flex flex-col gap-2 items-center text-center">
          <p className="text-[16px] text-accent font-dm-serif font-medium">Interview</p>
          <h2 className="text-[22px] font-bold text-black">フローリストに質問！</h2>
        </div>
        <dl>
          {QA.map(({ q, a }, index) => (
            <div key={q} className={`py-6 flex flex-col gap-2 ${index > 0 ? 'border-t border-gray/40' : ''}`}>
              <dt className="text-[16px] font-bold text-black leading-[1.4]">
                <span className="text-accent mr-2">Q.</span>
                {q}
              </dt>
              <dd className="text-[14px] leading-[1.7] text-[#858585]">{a}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
